export default __webpack_public_path__ + "static/media/Vector-2.5e0d5305.svg";